import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=48adbb1b&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"
import style0 from "./Alert.vue?vue&type=style&index=0&id=48adbb1b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48adbb1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48adbb1b')) {
      api.createRecord('48adbb1b', component.options)
    } else {
      api.reload('48adbb1b', component.options)
    }
    module.hot.accept("./Alert.vue?vue&type=template&id=48adbb1b&scoped=true", function () {
      api.rerender('48adbb1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/alert/Alert.vue"
export default component.exports